import { derived } from 'svelte/store';

import { designState } from './Designer.js';
import { teamDetails } from './TeamDetails.js';
import { environment } from '../environment/environment.js';
import { designElementSummary } from '../routes/design/[productSlug]/_design-functions.js';

const productTypes = environment.PRODUCT_TYPES;

// Calculate the total quantity of a product type, excluding any items with null size IDs. I.e. where the user has selected none.
const calculateQuantity = (teamDetails, type) => {
  return teamDetails.reduce((acc, curr) => {
    return curr[type + 'SizeId'] !== null ? acc + curr[type + 'Qty'] : acc;
  }, 0);
};

const productDetails = (design, type, teamDetails) => {
  const frontElementSummary = designElementSummary(design[type].designElements.front);
  const backElementSummary = designElementSummary(design[type].designElements.back);
  const rightSideElementSummary = designElementSummary(design[type].designElements.rightSide);
  const leftSideElementSummary = designElementSummary(design[type].designElements.leftSide);

  const includesEmbroidery =
    frontElementSummary?.summary.includes('embroidery') ||
    backElementSummary?.summary.includes('embroidery') ||
    rightSideElementSummary?.summary.includes('embroidery') ||
    leftSideElementSummary?.summary.includes('embroidery');

  let details = {
    product: {
      type: type,
      title: design[type].product.name,
      price: design[type].product.price,
      sponsorship: design[type].sponsorship,
      quantity: calculateQuantity(teamDetails, type),
    },
    designElements: {
      front: frontElementSummary,
      back: backElementSummary,
      rightSide: rightSideElementSummary,
      leftSide: leftSideElementSummary,
    },
    includesEmbroidery: includesEmbroidery,
  };

  return details;
};

export const productSummaryStore = derived([designState, teamDetails], ([$designState, $teamDetails]) => {
  const summary = {};
  const currentDesign = $designState[0]; // only one design for now

  for (const type of productTypes) {
    if (currentDesign && currentDesign[type]?.product) {
      summary[type] = productDetails(currentDesign, type, $teamDetails);
    } else {
      summary[type] = null;
    }
  }
  return summary;
});
